import { IGroupUser, ILatestActivity } from 'types/groups';
import { ActivityObjectTypeInfo } from '@cont/Groups/groupsConstants';

export interface IProfilePopupContentProps {
  selectedUser: IGroupUser;
}

export const computeLatestActivityTitle = (latestActivity: ILatestActivity) => {
  const { status, data, objectType } = latestActivity as ILatestActivity;
  if (ActivityObjectTypeInfo[objectType]) {
    const activityName = data.title;
    const prefixKey = status === 0 ? 'pastPrefix' : 'presentPrefix';
    return `${ActivityObjectTypeInfo[objectType][prefixKey]} ${activityName}`;
  }
  return null;
};

export const computeLatestActivityImage = (latestActivity: ILatestActivity) => {
  const { objectType } = latestActivity as ILatestActivity;

  if (ActivityObjectTypeInfo[objectType]) {
    return ActivityObjectTypeInfo[objectType].icon;
  }
  return 'groups/practice.svg';
};
